import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat'
})
export class PhoneFormatPipe implements PipeTransform {

  transform(phoneNumber: string | null): string {
    if (!phoneNumber) {
      return '';
    }

    // Hapus karakter non-digit
    const digits = phoneNumber.replace(/\D/g, '');

    // Pastikan nomor dimulai dengan kode negara Indonesia (62)
    if (!digits.startsWith('62')) {
      return phoneNumber; // Return original jika bukan format yang diharapkan
    }

    // Ambil bagian kode negara (62)
    const countryCode = digits.substring(0, 2);

    // Cek panjang nomor untuk menentukan format
    // Untuk nomor dengan format area (seperti Jakarta = 21)
    if (digits.length >= 10) {
      // Ambil kode area (2 digit setelah kode negara)
      const areaCode = digits.substring(2, 4);

      // Pisahkan sisa digit menjadi kelompok-kelompok
      const firstGroup = digits.substring(4, 8);
      const secondGroup = digits.substring(8);

      // Format nomor: (+62) 21 3111 1234
      return `(+${countryCode}) ${areaCode} ${firstGroup.substring(0, 4)} ${secondGroup.substring(0, 4)}`;
    }
    // Untuk nomor handphone (tanpa kode area terpisah)
    else {
      // Hapus kode negara (62)
      const number = digits.substring(2);

      // Format nomor handphone: (+62) 812 1888 8888
      const part1 = number.substring(0, 3);
      const part2 = number.substring(3, 7);
      const part3 = number.substring(7);

      return `(+${countryCode}) ${part1} ${part2} ${part3}`;
    }
  }

}
